import { guides } from '@/mocks/guides';
import GuideCard from '@/components/feature/GuideCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function HotGuidesSection() {
  const hot = guides.filter((g) => g.hot);
  const rest = guides.filter((g) => !g.hot);
  const list = [...hot, ...rest].slice(0, 6);

  return (
    <section id="guides" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100/60 border-y border-background-200">
      <SectionHeading
        eyebrow="最多人看"
        title="热门避雷清单"
        description="这几个月被反复翻看的几份清单，覆盖下单前后最容易踩的那些坑。"
        linkTo="/guides"
        linkLabel="全部清单"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {list.map((guide) => (
          <GuideCard key={guide.slug} guide={guide} />
        ))}
      </div>
    </section>
  );
}